import React, { useEffect, useState, createContext, useContext } from 'react';
interface AccessibilityContextType {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
  highContrast: boolean;
  setHighContrast: (value: boolean) => void;
  bigText: boolean;
  setBigText: (value: boolean) => void;
}
const AccessibilityContext = createContext<AccessibilityContextType | undefined>(undefined);
export function AccessibilityProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [darkMode, setDarkMode] = useState(false);
  const [highContrast, setHighContrast] = useState(false);
  const [bigText, setBigText] = useState(false);
  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) root.classList.add('dark-mode');else root.classList.remove('dark-mode');
    if (highContrast) root.classList.add('high-contrast');else root.classList.remove('high-contrast');
    if (bigText) root.classList.add('big-text');else root.classList.remove('big-text');
  }, [darkMode, highContrast, bigText]);
  return <AccessibilityContext.Provider value={{
    darkMode,
    setDarkMode,
    highContrast,
    setHighContrast,
    bigText,
    setBigText
  }} data-id="element-69" data-mp="1qnyjsyw7fc7b">
      {children}
    </AccessibilityContext.Provider>;
}
export function useAccessibility() {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility must be used within an AccessibilityProvider');
  }
  return context;
}